export default "__VITE_ASSET__3e750e25__"